import { render, staticRenderFns } from "./Godot.vue?vue&type=template&id=f3f6daca"
import script from "./Godot.vue?vue&type=script&lang=js"
export * from "./Godot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports